'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Eye = require('@olxbr/olx-icons/dist/System/Eye');

var _Eye2 = _interopRequireDefault(_Eye);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showPassword = function showPassword(props) {
  var onClick = props.onClick,
      enabled = props.enabled;

  return _react2.default.createElement(_Eye2.default, {
    onClick: onClick,
    size: 16,
    color: enabled ? '#4A4A4A' : '#D2D2D2'
  });
};

showPassword.propTypes = {
  enabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

showPassword.defaultProps = {
  enabled: false
};

exports.default = showPassword;